ResultUserModel = require('./result-model')

module.exports = class ResultUserCollection extends Backbone.Collection

  model: ResultUserModel